(function(teams, $, undefined)
{
    var sections;
    
    // cache
    var $_quickmenu;

    teams.init = function()
    {
        this.cacheInitialized = [];
        this.sections = {
            'index' : 'uiIndex',
            'teampage' : 'uiTeamPage'
        };
        
        main.loadPageEvents(jsData['subPage']);

        this.uiEvents();

        main.setStartingPushState();
    };

    teams.uiEvents = function()
    {

    };

    teams.uiIndex = function()
    {
	    
    };

    teams.uiTeamPage = function()
    {
        // cache
        this.$_quickmenu = $('#teams-quickmenu');

        if ('teampage' in this.cacheInitialized)
            return true;

        this.cacheInitialized['teampage'] = true;


	    teams.$_quickmenu.on('click', '.js-goto-ninja', clickNinjaGoto);
	    teams.$_quickmenu.find('.js-quickmenu-control').on('click', main.refreshQuickmenuControl);


        function clickNinjaGoto()
        {
            var $_this = $(this),
                tnid = $_this.data('tnid');

            var sendData = {
                'TN_ID' : tnid
            };

            $.ajaxHandler({
                url: '/teams/ninjaDetails',
                type: 'GET',
                data: sendData,
                cache: false
            }).done(function(data)
            {
                $_this.addClass('-c-sel').siblings().removeClass('-c-sel');

                $('#teams-ninja-content').html(data);

                main.displayNinjaGraphs($('#ninjaStatsGraph'), []);
            });
        }
    };

}(window.teams = window.teams || {}, jQuery));

$(function()
{
    teams.init();
});